import { Directive, HostListener, Optional } from '@angular/core';

import { SnDrawerRef } from '../references/drawer.reference';

@Directive({
  selector: '[snDrawerClose]',
})
export class SnDrawerCloseDirective {
  constructor(@Optional() private readonly _drawerRef: SnDrawerRef) {}

  @HostListener('click')
  public onClick(): void {
    if (this._drawerRef) {
      this._drawerRef.close();
    }
  }
}
